module.exports = __webpack_public_path__ + "img/61ne.15776d0d.svg";